// extracted by mini-css-extract-plugin
module.exports = {"root":"ApplicationPage_root__23mE7","loading":"ApplicationPage_loading__IcEyc","error":"ApplicationPage_error__mJgFj"};